import React, { useCallback, useEffect, useState, useRef } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { styled, useTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { FormControl, FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import NumberInput from '../../../components/Input/NumberInput';
import ButtonAction from '../../../components/Button.js/SaveButton';
import Loader from '../../../components/loader/loader';
import TextInput from 'src/components/Input/TextInput';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import ComboBox from 'src/components/Input/ComboBox';
import ChessBoardSelectCell from 'src/component-project/TableSelectedUser/ChessBoardSelectCell';
import LoaderHavePopup from 'src/component-project/loader_have_popup';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const RequestFixDeviceModel = ({ visible = false, callBackFunct, setVisible, data, idPermission }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [flagProcess, setFlagProcess] = useState(false);
    const [note, setNote] = useState('');
    const [quantity, setQuantity] = useState(1);
    const [dataDrawer, setDataDrawer] = useState([]);
    const [dataCell, setDataCell] = useState([]);
    const [selectDrawer, setSelectDrawer] = useState(0);
    const [selectedCell, setSelectedCell] = useState(null);
    const isFinishSelectCell =
        selectedCell !== null &&
        note.trim().length > 1 &&
        quantity !== null &&
        quantity !== 0 &&
        quantity <= data.qty &&
        data?.bussiness !== 'rde';
    const [isOpen, setIsOpen] = useState(false);
    const isHandledRef = useRef(false);


    const dataCabinet = glb_sv.getLocalStorageCabinet('cabinet')
    console.log(dataCabinet)
    const user = glb_sv.userInfo;
    const isAdmin = (user?.group_user === '1' || user?.group_user === '2') && data?.bussiness === 'rde';
    const [checkNotReturn, setcheckNotReturn] = useState(0);

    useEffect(() => {
        return () => {
            clearIntervalCheckStatusCell();
        };
    }, []);
    useEffect(() => {
        try {
            setIsOpen(false);
            setDataDrawer([]);
            setDataCell([]);
            if (data?.cabinet_id && visible && data?.device_cd) {
                isHandledRef.current = false;
                if (isAdmin || data.bussiness === 'rde') {
                    getDataDrawer(data?.cabinet_request_id);
                } else getDataDrawerSuggest(data?.cabinet_id, data?.device_cd);
            }
            if (!visible) {
                clearIntervalCheckStatusCell();
            }
        } catch (e) {}
    }, [visible]);

    useEffect(() => {
        try {
            if (selectDrawer !== 0) {
                setSelectedCell(null);
                getAllCell(data?.cabinet_id, selectDrawer);
            }

            if (selectDrawer === 0 && visible) {
                setDataCell([]);
                setSelectedCell(null);
            }
        } catch (e) {}
    }, [selectDrawer, data?.id, visible]);

    const getDataDrawer = useCallback(
        (id) => {
            const InVal = [id];
            sendRequest(serviceList.getAlldrawerSp, InVal, getDataDrawerResult, true, timeOutFunct, 40000);
        },
        [data?.cabinet_id, visible, data?.device_cd]
    );

    const getDataDrawerSuggest = useCallback(
        (id, device_cd) => {
            const InVal = [id, device_cd, data?.drawer_id];
            sendRequest(serviceList.getListDrawerAndSuggestCell, InVal, getDataDrawerResult, true, timeOutFunct, 40000);
        },
        [data?.cabinet_id, visible, data?.device_cd, data?.drawer_id]
    );

    const getDataDrawerResult = (reqInfoMap, message) => {
        setFlagProcess(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const drawerData = [...message.proc_data.rows[0].o_1];
            const drawerDataSuggest = message.proc_data?.suggest_drawer;
            drawerData.map((ele) => {
                setDataDrawer((prev) => {
                    if (prev.some((item) => item.value === ele.id)) return prev;

                    return [
                        ...prev,
                        {
                            label: ele.drawer_nm,
                            value: ele.id,
                            lc: ele.drawer_lc,
                        },
                    ];
                });
            });

            if (isAdmin || data?.bussiness === 'rde' || data?.status === '7') {
                setSelectDrawer(data?.drawer_request_id);
                setNote(data?.note_repair_device);
            } else {
                if (!drawerDataSuggest) {
                    toast.error(t('not_found_cell'));
                } else {
                    setSelectDrawer(drawerDataSuggest);
                }
            }
        }
    };

    const adminGet = useCallback(
        (id) => {
            const InVal = [id];
            sendRequest(serviceList.admin_get_in_cell, InVal, adminGetResult, true, timeOutFunct, 40000);
        },
        [data?.id]
    );

    const adminGetResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            // toast.success(message['proc_message']);
            // console.log("xongggg")
        }
    };

    const getAllCell = useCallback(
        (id_capinet, id_drawer) => {
            const InVal = [idPermission, id_capinet, id_drawer];
            sendRequest(serviceList.getAllbox, InVal, getDataCellResult, true, timeOutFunct, 40000);
        },
        [data?.cabinet_id, selectDrawer, visible, data?.id]
    );

    const getDataCellResult = (reqInfoMap, message) => {
        setFlagProcess(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setDataCell([...message.proc_data.rows[0].o_1]);
            if (isAdmin || data?.bussiness === 'rde' || data?.status === '7') {
                setSelectedCell([...message.proc_data.rows[0].o_1].find((ele) => ele.id === data.cell_request_id));
            } else {
                setSelectedCell(
                    message.proc_data.rows[0].o_1.filter((ele) => ele.device_id === null && ele.block_status === '1')[0]
                );
            }
        }
    };

    useEffect(() => {
        console.log('Current State -> flagProcess:', flagProcess);
    }, [flagProcess]);

    const handleClick = () => {
        console.log('handleClick called. isHandled:', isHandledRef.current);
        if (isHandledRef.current) return;
        clearIntervalCheckStatusCell();
        isHandledRef.current = true;
        setFlagProcess(true);
        const InVal = [
            data.device_id,
            parseInt(quantity),
            note,
            data.cabinet_id,
            selectDrawer,
            selectedCell.id,
            data.id,
            checkNotReturn,
        ];
        sendRequest(serviceList.actionReportDamaged, InVal, actionResult, true, timeOutFunct, 600000);
    };

    const actionResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            setFlagProcess(false);
            isHandledRef.current = false;
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            closeCell();
        }
    };
    // region open cell
    const openCell = (data) => {
        const cabinetAtAccount = glb_sv.getLocalStorageCabinet('cabinet');
        if (data?.cabinet_cd !== cabinetAtAccount?.cabinet_cd && data.status !== 7 && data.bussiness == 'rde') {
            toast.error(t('select_right_cabinet'));
            return;
        }
        if (quantity > data?.qty) {
            toast.error(t('warning_qty_change_device'));
            return;
        }
        setFlagProcess(true);
        let service = serviceList.openCellIOT;
        const drawer_lc_select = dataDrawer.find((ele) => ele.value === (data?.drawer_request_id || selectDrawer))?.lc;
        let inpuVal = [
            data.cabinet_request_cd || data.cabinet_cd,
            drawer_lc_select,
            selectedCell?.cell_lc.row,
            selectedCell?.cell_lc.column,
        ];

        if (data?.cabinet_type !== 'round') {
            service = serviceList.openCellIOT;
            inpuVal = [
                data.cabinet_request_cd || data.cabinet_cd,
                drawer_lc_select,
                selectedCell.cell_lc.row,
                selectedCell.cell_lc.column,
            ];
        } else {
            service = serviceList.openCellIOTCabinetV2;
            inpuVal = [
                data.cabinet_request_cd || data.cabinet_cd,
                drawer_lc_select,
                selectedCell.cell_lc.column,
                selectedCell.column,
            ];
        }
        sendRequest(service, inpuVal, openCellResult, true, timeOutFunct, 40000, 0);
    };

    const openCellResult = (reqInfoMap, message) => {
        console.log('reqInfoMap', reqInfoMap['input_param']);
        setFlagProcess(false);

        if ((message['proc_status']?.toString() || '0') === '0') {
            // closeCell();
            toast.error('Error: ' + message['proc_message']);
        } else {
            setIsOpen(true);
            if (data?.bussiness === 'rde') adminGet(data?.id);
            // gọi api kiểm tra trạng thái ô sau 5s
            const input_param = reqInfoMap['input_param'];
            setTimeout(() => {
                handleIntervalCheckStatusCell(input_param[0], input_param[1], input_param[2]);
            }, 5000);
        }
    };

    // region closeCell
    const closeCell = () => {
        let service = serviceList.closeCellIOT;
        const drawer_lc_select = dataDrawer.find((ele) => ele.value === ele.id)?.lc;
        clearIntervalCheckStatusCell();
        let inpuVal = [
            data.cabinet_request_cd,
            drawer_lc_select,
            selectedCell.cell_lc.row,
            selectedCell.cell_lc.column,
        ];
        if (data?.cabinet_type !== 'round') {
            service = serviceList.closeCellIOT;
            inpuVal = [
                data.cabinet_request_cd,
                drawer_lc_select,
                selectedCell.cell_lc.row,
                selectedCell.cell_lc.column,
            ];
        } else {
            service = serviceList.closeCellIOTCabinetV2;
            inpuVal = [data.cabinet_request_cd, drawer_lc_select, selectedCell.cell_lc.row, selectedCell.column];
        }
        sendRequest(service, inpuVal, closeCellResult, true, timeOutFunct, 40000, 0);
        // console.log('inpuValClose: ', inpuVal);
        // console.log('serviceListClose: ', service);
    };

    // region closeCellResult
    const closeCellResult = (reqInfoMap, message) => {
        setFlagProcess(false);
        isHandledRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
        } else {
            setIsOpen(false);
            callBackFunct && callBackFunct();
        }
        clearIntervalCheckStatusCell();
    };

    // region checkStatusCell START
    const checkIntervalCheckStatusCell = useRef(null);
    const checkStatusCellFlag = useRef(false);
    const handleIntervalCheckStatusCell = (cabinet_cd, drawer_id, cell_address) => {
        checkIntervalCheckStatusCell.current = setInterval(() => {
            checkStatusCell(cabinet_cd, drawer_id, cell_address);
        }, 3000);
    };
    const clearIntervalCheckStatusCell = () => {
        console.log('checkIntervalCheckStatusCell.current', checkIntervalCheckStatusCell.current);
        clearInterval(checkIntervalCheckStatusCell.current);
        checkIntervalCheckStatusCell.current = null;
        checkStatusCellFlag.current = false;
    };
    const checkStatusCell = (cabinet_cd, drawer_id, cell_address) => {
        console.log('checkIntervalCheckStatusCell.current', checkIntervalCheckStatusCell.current);
        if (!cabinet_cd || !drawer_id || !cell_address || checkStatusCellFlag.current) return;
        checkStatusCellFlag.current = true;
        const inpuVal = [cabinet_cd, drawer_id, cell_address];
        sendRequest(
            serviceList.checkStatusCell,
            inpuVal,
            checkStatusCellResult,
            true,
            checkStatusCellTimeOut,
            40000,
            0
        );
    };
    const checkStatusCellResult = (reqInfoMap, message) => {
        checkStatusCellFlag.current = false;
        console.log(
            'checkStatusCellResult',
            (message['proc_code']?.toString() || '1') === '1' && (message['proc_status']?.toString() || '1') === '1'
        );
        if ((message['proc_code']?.toString() || '1') === '1' && (message['proc_status']?.toString() || '1') === '1') {
            if (!data?.cell_request_id && !data?.cabinet_request_id && !data?.drawer_request_id) {
                if (!isHandledRef.current || !flagProcess) {
                    handleClick();
                }
            } else {
                closeCell();
            }
        }
    };
    const checkStatusCellTimeOut = (reqInfo) => {
        checkStatusCellFlag.current = false;
        setFlagProcess(false);
        toast.error(t('error.request_timeout'));
    };

    const timeOutFunct = (reqInfo) => {
        setFlagProcess(false);
        setIsOpen(false);
        toast.error(t('error.time_out'));
    };

    const handleQuantityChange = (val) => {
        if (val <= data.qty) {
            setQuantity(val);
        } else {
            setQuantity(data.qty);
        }
    };
    return (
        <BootstrapDialog
            fullScreen={fullScreen}
            open={visible}
            aria-labelledby="customized-dialog-title"
            PaperProps={{ component: 'div' }}
        >
            <BootstrapDialogTitle
                onClose={() => {
                    setVisible(!visible);
                }}
                id="customized-dialog-title"
            >
                {t('bad_report')} <br /> {t('name_device')}: {data?.device_cd}_{data?.device_nm}
            </BootstrapDialogTitle>
            <Loader loading={flagProcess || isHandledRef.current} />
            <LoaderHavePopup loading={flagProcess && isHandledRef.current} popupText={t('processing_with_popup')} />
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item style={{ width: '100%' }} xl={12} md={12} sm={12}>
                        <NumberInput
                            label={t('number_of_damaged')}
                            valueChange={quantity}
                            size="medium"
                            getValue={handleQuantityChange}
                            disabled={isAdmin || data?.status === '7' || data?.bussiness === 'rde'}
                        />
                    </Grid>
                    <Grid item style={{ width: '100%' }} xl={12} md={12} sm={12}>
                        <TextInput
                            // ref={noteRef}
                            size="medium"
                            label={t('enter_note')}
                            valueChange={note}
                            onEnterPress={handleClick}
                            required
                            getValue={setNote}
                            autoFocus
                            disabled={isAdmin || data?.status === '7' || data?.bussiness === 'rde'}
                        />
                    </Grid>

                    <Grid
                        item
                        xl={12}
                        md={12}
                        sm={12}
                        style={{ width: '100%', alignItems: 'center', justifyContent: 'center' }}
                    >
                        <FormControl>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                            >
                                <FormControlLabel
                                    disabled={isAdmin || data?.status === '7' || data?.bussiness === 'rde'}
                                    value="yes"
                                    control={
                                        <Radio
                                            checked={checkNotReturn === 1}
                                            onClick={() => {
                                                setcheckNotReturn(1);
                                            }}
                                        />
                                    }
                                    // checked={valueCheck.notReturn}
                                    label={t('device_damaged') + ' ' + t('before_use').toLocaleLowerCase()}
                                />
                                <FormControlLabel
                                    disabled={isAdmin || data?.status === '7' || data?.bussiness === 'rde'}
                                    value="no"
                                    control={
                                        <Radio checked={checkNotReturn === 0} onClick={() => setcheckNotReturn(0)} />
                                    }
                                    // checked={valueCheck.return}
                                    label={t('device_damaged') + ' ' + t('during_use').toLocaleLowerCase()}
                                />
                            </RadioGroup>
                        </FormControl>
                    </Grid>

                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%', marginTop: 7 }}>
                        <ComboBox
                            label={t('choose_drawer')}
                            sizeCbb="medium"
                            displayLabel="label"
                            valueEqual="value"
                            valueSelect={dataDrawer.find((ele) => ele.value === selectDrawer)}
                            getValue={(e) => setSelectDrawer(e?.value || 0)}
                            selectOption={dataDrawer}
                            required
                            disabled={true}
                            // disabled={isAdmin || data?.status === 'rde' || data?.bussiness === 'rde'}
                        />
                    </Grid>

                    {dataCell?.length > 0 && (
                        <>
                            <Typography variant="h5" sx={{ mt: 2, textAlign: 'center', width: '100%' }}>
                                {t('select_empty_cell')}
                            </Typography>
                            <ChessBoardSelectCell
                                typeCabinet={data?.cabinet_type}
                                cell_id_request={data?.cell_request_id}
                                onSelect={(pos) => {
                                    if (!isAdmin && data?.bussiness !== 'rde' && data?.status !== '7') {
                                        setSelectedCell(pos);
                                        // console.log('Bạn đã chọn vị trí:', pos.cell_lc);
                                    }
                                }}
                                dataCell={dataCell}
                                selectedCell={selectedCell}
                            />
                        </>
                    )}
                </Grid>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                {isAdmin &&
                    (!isOpen ? (
                        <ButtonAction
                            disabled={data?.status === '7'}
                            onClick={() => {
                                openCell(data);
                            }}
                            type={'confirm'}
                            icon="send"
                            title={t('open_cell_output')}
                        />
                    ) : (
                        <ButtonAction
                            onClick={() => {
                                closeCell();
                            }}
                            type={'confirm'}
                            icon="send"
                            title={t('confrim_success')}
                        />
                    ))}
                <ButtonAction
                    onClick={() => {
                        setVisible(!visible);
                    }}
                    type={'cancel'}
                    title={t('cancel')}
                />
                {isOpen && data?.bussiness !== 'rde' && data?.status !== '7' ? (
                    <ButtonAction
                        onClick={() => {
                            handleClick();
                        }}
                        type={'confirm'}
                        icon="send"
                        title={t('confrim_success')}
                    />
                ) : (
                    <ButtonAction
                        disabled={!isFinishSelectCell}
                        onClick={() => {
                            openCell(data);
                            // handleClick();
                        }}
                        type={'confirm'}
                        icon="send"
                        title={t('open_cell_input')}
                    />
                )}
            </DialogActions>
        </BootstrapDialog>
    );
};

export default RequestFixDeviceModel;
